import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { Fleet } from "./components/site/Fleet";
import { About } from "./components/site/About";
import { Requirements } from "./components/site/Requirements";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";

const Home = () => (
  <div data-testid="home-page" className="bg-paper min-h-screen">
    <Header />
    <main>
      <Hero />
      <Fleet />
      <About />
      <Requirements />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
